if (!customElements.get('image-product-slider')) {
  customElements.define('image-product-slider', class extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector('scroll-carousel');
      this.previousButton = this.querySelector('[data-slider-previous]');
      this.nextButton = this.querySelector('[data-slider-next]');

      if (!this.carousel || !this.previousButton || !this.nextButton) {
        return;
      }

      this.abortController = new AbortController();
      this.previousButton.addEventListener('click', () => this.carousel.previous(), { signal: this.abortController.signal });
      this.nextButton.addEventListener('click', () => this.carousel.next(), { signal: this.abortController.signal });
      this.carousel.addEventListener('scroll:edge-nearing', (event) => this.updateButton(event.detail.position, true), { signal: this.abortController.signal });
      this.carousel.addEventListener('scroll:edge-leaving', (event) => this.updateButton(event.detail.position, false), { signal: this.abortController.signal });
      this.updateButtons();
      requestAnimationFrame(() => this.updateButtons());
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }
    }

    updateButton(position, disabled) {
      if (position === 'start') {
        this.previousButton.disabled = disabled;
      } else if (position === 'end') {
        this.nextButton.disabled = disabled;
      }
    }

    updateButtons() {
      this.previousButton.disabled = Math.abs(this.carousel.scrollLeft) <= 1;
      this.nextButton.disabled = this.carousel.scrollWidth - this.carousel.clientWidth - Math.abs(this.carousel.scrollLeft) <= 1;
    }
  });
}